<div
  #viewport
  class="cropper"
  [ngClass]="{
    dragging: isDragging
  }"
  [ngStyle]="frameStyle"
  (pointerdown)="onPointerDown($event)"
  (wheel)="onWheel($event)"
  >
  <img
    #imageElement
    [src]="url"
    alt="photo"
    draggable="false"
    [ngStyle]="imageStyle"
    (load)="onImageLoad()"
    />

    @if (selectedPoint && url) {
      <div class="focusPoint" [ngStyle]="focusStyle"></div>
    }

    @if (showHint) {
      <div class="hint">
        Kliknij na zdjeciu, aby ustawic punkt centralny. Kolo myszy zmienia powiekszenie.
      </div>
    }
  </div>
